export const ReviewIcon = () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.6415 72.916H33.3124C27.6999 72.916 24.8892 79.7463 28.8578 83.7411L59.8176 114.904C61.0453 116.14 61.7003 117.818 61.6612 119.534C61.6444 120.269 61.3934 120.972 61.102 121.647L42.656 164.38C42.3645 165.055 42.114 165.759 42.0904 166.494C41.9301 171.495 47.6149 174.874 51.964 171.864L96.431 148.309C98.5808 146.821 101.419 146.821 103.569 148.309L148.036 171.864C152.385 174.874 158.07 171.495 157.91 166.494C157.886 165.759 157.635 165.055 157.344 164.38L138.898 121.647C138.607 120.972 138.356 120.269 138.339 119.533C138.3 117.818 138.955 116.14 140.182 114.904L171.142 83.7411C175.111 79.7463 172.3 72.916 166.688 72.916H126.359C123.76 72.916 121.429 71.3106 120.487 68.8732L105.871 31.0428C103.789 25.6524 96.2112 25.6524 94.1286 31.0428L79.5129 68.8732C78.5712 71.3106 76.2396 72.916 73.6415 72.916Z"
        className="fill-[#060C3B] dark:fill-neutral-300"
        fillOpacity="0.2"
      />
      <path
        d="M126.359 72.916H166.688C172.3 72.916 175.111 79.7464 171.142 83.7411L140.182 114.904C138.955 116.14 138.3 117.818 138.339 119.534C138.356 120.269 138.607 120.972 138.898 121.647L157.344 164.38C157.635 165.055 157.886 165.759 157.91 166.494C158.07 171.495 152.385 174.874 148.036 171.864L103.569 148.309C102.494 147.565 101.247 147.193 100 147.193V27C102.415 27 104.83 28.3476 105.871 31.0428L120.487 68.8732C121.429 71.3106 123.76 72.916 126.359 72.916Z"
        className="fill-[#060C3B] dark:fill-neutral-500"
        fillOpacity="0.2"
      />
    </svg>
  );
};
